import { OperatorApi } from './operator-api';
import { OperatorApp, OperatorAppsResponse } from '../types/operator-types';

export class OperatorRepository {
  constructor(private readonly operatorApi: OperatorApi) {}

  async getOperatorApps(): Promise<OperatorApp[]> {
    try {
      const response: OperatorAppsResponse = await this.operatorApi.getOperatorApps();
      return response.rows || [];
    } catch (error) {
      console.error('Error fetching operator apps:', error);
      throw error;
    }
  }

  /**
   * Find operator by ID from a list - matches Dart implementation logic
   */
  findOperatorById(operators: OperatorApp[], operatorId: number): OperatorApp | null {
    return operators.find(op => op.operatorId === operatorId) || null;
  }

  /**
   * Validate operator belongs to distributor - security check
   */
  validateOperatorBelongsToDistributor(operator: OperatorApp, distributorId: string): boolean {
    return operator.distributorId.toString() === distributorId;
  }
}